"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OEmbedLoader_1 = require("../components/OEmbedLoader");
function htmlToElement(html) {
    var span = document.createElement("span");
    span.innerHTML = html.trim();
    return span;
}
exports.htmlToElement = htmlToElement;
function runJs(scriptElement) {
    var head = document.getElementsByTagName("head")[0];
    if (scriptElement.src) {
        var script = document.createElement("script");
        console.log("Load external script", scriptElement);
        script.src = scriptElement.src;
        head.appendChild(script);
    }
    else {
        try {
            console.log("Eval inline script", scriptElement);
            eval(scriptElement.innerHTML);
        }
        catch (e) {
            console.log("Can't eval inline script", scriptElement);
        }
    }
}
exports.runJs = runJs;
function loadAllScripts(templateElement) {
    var scripts = templateElement.querySelectorAll("script");
    if (scripts.length) {
        console.log("Activate scripts", scripts);
        [].slice.call(scripts).forEach(function (script) {
            runJs(script);
        });
    }
    new OEmbedLoader_1.OEmbedLoader('.soundcloud-embed', 'jsonp', 'https://soundcloud.com/oembed?format=js&url=');
    new OEmbedLoader_1.OEmbedLoader('.twitter-embed', 'jsonp', 'https://api.twitter.com/1/statuses/oembed.json?url=');
    new OEmbedLoader_1.OEmbedLoader('.instagram-embed', 'json', 'https://api.instagram.com/oembed?url=');
}
exports.loadAllScripts = loadAllScripts;
function cleanUp(elements) {
    elements.forEach(function (element) {
        if (element.classList.contains("blocked-content-container")) {
            element.classList.add("hidden-cmp-content");
            element.addEventListener("animationend", function () {
                [].slice
                    .call(document.querySelectorAll(".unblocked.hidden-cmp-content"))
                    .forEach(function (unblocked) {
                    unblocked.classList.remove("hidden-cmp-content");
                });
                element.remove();
            });
        }
        else {
            element.remove();
        }
    });
}
exports.cleanUp = cleanUp;
function activateTemplate(button, template) {
    if (button) {
        var templateElement = htmlToElement(template.nodeName === "TEXTAREA"
            ? template.value
            : template.innerHTML);
        templateElement.classList.add("unblocked");
        templateElement.classList.add("hidden-cmp-content");
        templateElement.classList.add("inline-content");
        templateElement.classList.add("block");
        if (templateElement) {
            button.parentElement.insertBefore(templateElement, button);
            loadAllScripts(templateElement);
            cleanUp([button, template]);
        }
    }
}
exports.activateTemplate = activateTemplate;
function activateVendor(vendorName) {
    console.log("activate vendor", vendorName);
    var templates = [].slice.call(document.querySelectorAll("textarea[data-vendor-name=\"" + vendorName + "\"],template[data-vendor-name=\"" + vendorName + "\"],script[data-vendor-name=\"" + vendorName + "\"]"));
    if (templates.length) {
        templates.forEach(function (template) {
            activateTemplate(template.closest(".blocked-content-container[data-vendor-name=\"" + vendorName + "\"]"), template);
        });
    }
}
exports.activateVendor = activateVendor;
function showLock(vendorName) {
    console.log("lock vendor", vendorName);
    var templates = [].slice.call(document.querySelectorAll(".blocked-content-container[data-vendor-name=\"" + vendorName + "\"]"));
    if (templates.length) {
        templates.forEach(function (template) {
            template.style.visibility = "visible";
            template.style.height = "auto";
        });
    }
}
exports.showLock = showLock;
